var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentContainer',[_c('div',{staticClass:"u-text-h2 edit-user__title"},[_vm._v("Product Create")]),_c('ProductCreate',{attrs:{"isSchool":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }